import { render } from "./input.vue?vue&type=template&id=6237a8f6&scoped=true"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"

import "./input.vue?vue&type=style&index=0&id=6237a8f6&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6237a8f6"]])

export default __exports__